import React, { useState } from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { Divider, Button, Tooltip } from "@mui/material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { Cancel, Edit } from "@mui/icons-material";
import useGlobalState from "../../Context";

export default function Action({
  onClickPreview,
  onClickEdit,
  status,
  onClickCancel,
  userId,
  isEditFlag,
  isCancelFlag,
}) {
  const [{ userDetails }] = useGlobalState();
  const userParam = userDetails?.userParam;
  const currentUserId = userParam?.userId;
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const onClickAction = (onclick) => {
    handleClose();
    onclick();
  };

  return (
    <div>
      <Button
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        <MoreHorizIcon />
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem onClick={() => onClickAction(onClickPreview)} disableRipple>
          <RemoveRedEyeIcon sx={{ mr: 1 }} color={"info"} />
          Preview
        </MenuItem>
        <Divider />
        {status === 7 ||
        status === 4 ||
        status === 2 ||
        status === 1 ||
        currentUserId !== userId ? (
          <MenuItem disabled>
            <Edit color="primary" sx={{ mr: 1 }} />
            Edit
          </MenuItem>
        ) : isEditFlag ? (
          <MenuItem onClick={onClickEdit}>
            <Edit color="primary" sx={{ mr: 1 }} />
            Edit
          </MenuItem>
        ) : (
          <Tooltip
            title="Past day appointment edit is not allowed"
            placement="top-start"
            arrow
          >
            <MenuItem disableRipple>
              <Edit color="primary" sx={{ mr: 1 }} />
              Edit
            </MenuItem>
          </Tooltip>
        )}
        <Divider />
        {status === 7 ||
        status === 4 ||
        status === 2 ||
        status === 1 ||
        currentUserId !== userId ? (
          <MenuItem disabled>
            <Cancel color="error" sx={{ mr: 1 }} />
            Cancel Appointment
          </MenuItem>
        ) : isCancelFlag ? (
          <MenuItem onClick={() => onClickAction(onClickCancel)}>
            <Cancel color="error" sx={{ mr: 1 }} />
            Cancel Appointment
          </MenuItem>
        ) : (
          <Tooltip
            title="Past day appointment cancellation is not allowed"
            placement="top-start"
            arrow
          >
            <MenuItem disableRipple>
              <Cancel color="error" sx={{ mr: 1 }} />
              Cancel Appointment
            </MenuItem>
          </Tooltip>
        )}
      </Menu>
    </div>
  );
}
